
import React from 'react';
import { X, Clock, Repeat, CalendarClock, Award } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export interface PlanOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
  color?: string;
  textColor?: string;
  mobileBackgroundColor?: string;
  badgeVariant?: "default" | "secondary" | "destructive" | "outline";
}

// Updated plan options with vibrant mobile-specific background colors that match the icon colors
export const PLAN_OPTIONS: PlanOption[] = [
  { 
    value: "pending", 
    label: "Pending", 
    icon: <Clock className="h-4 w-4 text-gray-500" />,
    color: "bg-gray-200",
    textColor: "text-gray-500",
    mobileBackgroundColor: "bg-gray-500",
    badgeVariant: "secondary"
  },
  { 
    value: "monthly", 
    label: "Monthly", 
    icon: <Repeat className="h-4 w-4 text-blue-500" />,
    color: "bg-blue-100",
    textColor: "text-blue-500",
    mobileBackgroundColor: "bg-blue-500",
    badgeVariant: "secondary"
  },
  { 
    value: "annual", 
    label: "Annual", 
    icon: <CalendarClock className="h-4 w-4 text-green-500" />,
    color: "bg-green-100",
    textColor: "text-green-500",
    mobileBackgroundColor: "bg-green-500",
    badgeVariant: "secondary"
  },
  { 
    value: "lifetime", 
    label: "Lifetime", 
    icon: <Award className="h-4 w-4 text-amber-500" />,
    color: "bg-amber-100",
    textColor: "text-amber-500",
    mobileBackgroundColor: "bg-amber-500",
    badgeVariant: "secondary"
  },
  { 
    value: "canceled", 
    label: "Cancelled", 
    icon: <X className="h-4 w-4 text-red-500" />,
    color: "bg-red-100",
    textColor: "text-red-500",
    mobileBackgroundColor: "bg-red-500",
    badgeVariant: "secondary"
  }
];

// Helper function to normalize plan names for consistent comparison
export const normalizePlan = (plan: string): string => {
  if (!plan) return "pending";
  return plan.toLowerCase();
};

// Helper to get a specific plan option by value
export const getPlanOption = (value: string): PlanOption => {
  const normalizedValue = normalizePlan(value);
  return PLAN_OPTIONS.find(option => option.value === normalizedValue) || PLAN_OPTIONS[0];
};
